import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AUTH_LOGIN_URL } from '../api/guru';
import { useAuth } from '../context/AuthContext';
import guruLogo from '../assets/guru-logo.png';

const ERROR_MESSAGES = {
  oauth_failed:       'Google sign-in failed. Please try again.',
  domain_not_allowed: 'Please sign in with your 88gravity Google Workspace account.',
};

export default function Login() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="auth-loading">Loading…</div>;
  if (user)    return <Navigate to="/chat" replace />;

  const errorCode = new URLSearchParams(location.search).get('error');
  const errorMsg  = errorCode ? (ERROR_MESSAGES[errorCode] || 'Sign-in failed. Please try again.') : null;

  return (
    <div className="login-page">
      {/* Decorative orange vector blobs */}
      <svg className="login-blob login-blob-tl" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="blobTL" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FF6B1A" stopOpacity="0.45"/>
            <stop offset="100%" stopColor="#FF6B1A" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <ellipse cx="200" cy="200" rx="200" ry="180" fill="url(#blobTL)"/>
      </svg>
      <svg className="login-blob login-blob-br" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="blobBR" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FF8C00" stopOpacity="0.35"/>
            <stop offset="100%" stopColor="#FF8C00" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <ellipse cx="200" cy="200" rx="200" ry="180" fill="url(#blobBR)"/>
      </svg>
      <svg className="login-blob login-blob-tr" viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="blobTR" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FF4E6A" stopOpacity="0.20"/>
            <stop offset="100%" stopColor="#FF4E6A" stopOpacity="0"/>
          </radialGradient>
        </defs>
        <ellipse cx="150" cy="150" rx="150" ry="150" fill="url(#blobTR)"/>
      </svg>

      <div className="login-card">
        <img src={guruLogo} alt="Guru" className="login-logo" />
        <div className="login-title">Guru</div>
        <div className="login-sub">Sign in to your 88gravity workspace</div>

        {errorMsg && (
          <div className="alert alert-error login-alert">{errorMsg}</div>
        )}

        <a className="login-google-btn" href={AUTH_LOGIN_URL}>
          <svg className="login-google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </a>

        <p className="login-hint">Restricted to 88gravity Google Workspace accounts.</p>
      </div>

      <div className="login-footer-brand">
        <span className="lb-88">88</span><span className="lb-gravity">gravity</span>
      </div>
    </div>
  );
}
